import { Component, Input } from '@angular/core';
import { ToolbarConfig } from '../../../models/table/toolbar-config.interface';

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrl: './toolbar.component.scss'
})
export class ToolbarComponent<T> {
    @Input() toolbarConfig!: ToolbarConfig<T>;
    @Input() showSelected!: boolean;
    @Input() selection!: T[];
}
